import { fetchInsuranceIntermediaries } from '@/features/promo';
import { Env } from '@/shared/config/environment';

const state = {
  insuranceIntermediaries: null,
  isLoadingInsuranceIntermediaries: false,
  insuranceIntermediariesError: null,
};

const mutations = {
  SET_INSURANCE_INTERMEDIARIES: (state, insuranceIntermediaries) => {
    state.insuranceIntermediaries = insuranceIntermediaries;
  },
  SET_LOADING_INSURANCE_INTERMEDIARIES: (state, isLoading) => {
    state.isLoadingInsuranceIntermediaries = isLoading;
  },
  SET_INSURANCE_INTERMEDIARIES_ERROR: (state, error) => {
    state.insuranceIntermediariesError = error;
  },
};

const actions = {
  async fetchInsuranceIntermediaries({ commit, dispatch }) {
    commit('SET_LOADING_INSURANCE_INTERMEDIARIES', true);
    commit('SET_INSURANCE_INTERMEDIARIES_ERROR', null);
    commit('SET_INSURANCE_INTERMEDIARIES', null);

    try {
      const insuranceIntermediaries = await fetchInsuranceIntermediaries();
      commit('SET_INSURANCE_INTERMEDIARIES', insuranceIntermediaries);

      return insuranceIntermediaries;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список страхових посередників';

      commit('SET_INSURANCE_INTERMEDIARIES_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список страхових посередників',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_INSURANCE_INTERMEDIARIES', false);
    }
  },
};

const getters = {
  isLoadingInsuranceIntermediaries: state => state.isLoadingInsuranceIntermediaries,
  insuranceIntermediariesError: state => state.insuranceIntermediariesError,

  isInsuranceIntermediariesReady: state => { return state.isLoadingInsuranceIntermediaries === false && state.insuranceIntermediaries !== null; },
  getInsuranceIntermediaries: state => state.insuranceIntermediaries,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
